(function ($) {

    $(document).ready(function () {

        $(".makelist .level-2 > a").on("click", function(e){
            if ($(window).width() < 768) {
                e.preventDefault();
                const openClass = "is-open";
                const $children = $(this).nextUntil(".makelist .level-2 > a");

                if ($(this).hasClass(openClass)) {
                    $children.removeClass("visible");
                    $(this).removeClass(openClass);
                } else {
                    $("." + openClass).removeClass(openClass).nextUntil(".makelist .level-2 > a").removeClass("visible");
                    $children.addClass("visible");
                    $(this).addClass(openClass);

                    $("html, body").animate({
                        scrollTop: $("." + openClass).offset().top - 100
                    });
                }
            } 
        });

        $(".makelist .level-2 > a").each(function(e){
            if ($(window).width() < 768) {
                const categoryUrl = $(this).attr('href');
                const categoryText = $(this).text();
                const currentyNav = $(this).parent().find("> .nav");

                $('<a>',{
                    text: 'Bekijk alle ' + categoryText,
                    href: categoryUrl
                }).appendTo(currentyNav).wrap('<li class="level-3 show-all-link"></li>');
            }
        });
    });

})(jQuery);